<section [class]="'flex justify-content-center ' + (editMode ? '' : 'mt-4')">
	<div [class]="editMode ? 'col-12' : 'col-10'">
		<main class="formgrid p-fluid">
			<p-card  styleClass="px-5 mb-4 py-2 shadow-3 border-round-3xl">
				<div class="title  font-23   text-uppercase font-principal app-title-page-color font-medium mb-4">
					{{(editMode ? 'msg.editarHojaDeVida' : 'app-menu.tramite-wizard') |translate}}
				</div>
				<p-steps [model]="items" [readonly]="true" [activeIndex]="activeIndex"></p-steps>
			</p-card>

			<p-card styleClass="px-5 mb-4 py-2 shadow-3 border-round-3xl">
				<div [ngSwitch]="activeIndex">
					<div *ngSwitchCase="this.tabs.INFORMACION_GENERAL">
						<app-wizard-tipo-tramite-form [tipoTramiteId]="savedTipoTramiteId"></app-wizard-tipo-tramite-form>
					</div>
					<div *ngSwitchCase="this.tabs.TRAMITE_COSTO">
						<app-tipo-tramite-costo [tipoTramiteId]="savedTipoTramiteId"> </app-tipo-tramite-costo>
					</div>
					<div *ngSwitchCase="this.tabs.ACTIVIDADES">
						<app-admin-tipo-tramite-actividad [tipoTramiteId]="savedTipoTramiteId">
						</app-admin-tipo-tramite-actividad>
					</div>
					<div *ngSwitchCase="this.tabs.FINAL">
						<div>
							@if(editMode){
								{{'components.app-tramite-wizard.finalizar-mensaje-edit'|translate}}
							}
							@else {
								{{'components.app-tramite-wizard.finalizar-mensaje'|translate}}
							}
						</div>
					</div>
				</div>
				<ng-template pTemplate="footer">
					<div class="footer">
						<div>
							<p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate"
								(onClick)="prevPage()" icon="pi pi-angle-left"></p-button>
						</div>
						<div>
							<p-button *ngIf="showNextPageButton" [label]="'form.button.siguiente' | translate"
								(onClick)="nextPage()" icon="pi pi-angle-right" iconPos="right"></p-button>
							<p-button *ngIf="isLastPage" [label]="'form.button.finalizar' | translate"
								(onClick)="Finish()" icon="pi pi-angle-right" iconPos="right"
								styleClass="p-button-success"></p-button>
						</div>
					</div>
				</ng-template>
			</p-card>

		</main>
	</div>
</section>
